import { downloadCsv } from '@quickbit/backoffice-core-frontend';
import { SettlementReportDetails } from './types';

export const downloadReport = ({
  orders,
  refunds,
  ...report
}: SettlementReportDetails) => {
  const dataArray = [
    'Overview',
    'Currency: Euro',
    'Total sales volume,Settlement amount,Processing fee,Settlement fee,Total order count,Gateway fee,',
    `${report.totalAmount},${report.settlementAmount},${report.processingFee},${report.settlementFee},${report.orderCount},${report.gatewayFee}`,
  ];

  const ordersArray = [
    '',
    'Orders',
    ['Completed at', 'Order ID', 'Reference ID', 'Amount', 'Fee'].join(','),
    ...orders.map((row) =>
      [
        row.completedAt?.toLocaleString().replace(',', ' '),
        row.uuid,
        row.referenceId,
        row.settlement?.euroAmount ?? '-',
        row.settlement?.euroFee ?? '-',
      ].join(',')
    ),
  ];

  const refundsArray = [
    '',
    'Refunds',
    ['Created at', 'Order ID', 'Amount'].join(','),
    ...refunds.map((row) =>
      [
        row.createdAt.toLocaleString().replace(',', ' '),
        row.orderId,
        `${row.refundAmount} ${row.currency}`,
      ].join(',')
    ),
  ];

  const reportArray = [...dataArray, ...ordersArray, ...refundsArray];

  const dateString = `${report.startTime.toISOString()}_${report.endTime.toISOString()}`;
  const csvAsString = reportArray.join('\r\n');
  downloadCsv(csvAsString, `quickbit_settlement_report_${dateString}.csv`);
};
